import type { FC, SVGProps } from 'react';

export const FcpEuroLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 550 450"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Brake disc outer ring */}
    <path
      fill="currentColor"
      d="M409.9,440.4c-11-11.5-21.6-29.3-.4-52.9,15.3-16.9,24.7-44.4,23-70.9-1-17.1-7.7-40.4-28.9-59.6-5.4-4.9-10.6-12-9.3-19.9.7-4.7,2.2-10.3,10.1-18.5,10.6-10.9,16.7-16.5,32.5-32.8-29.2-19.8-70.7-36.5-108.3-36.5-98.9,0-179.1,78.9-179.1,176.1s80.2,176.1,179.1,176.1,78.8-14.4,107.3-32.7c-8.8-9.2-13.1-14.8-26.1-28.4M328.7,375.8c-28.3,0-51.3-22.6-51.3-50.4s23-50.4,51.3-50.4,51.3,22.6,51.3,50.4-23,50.4-51.3,50.4Z"
    />
    {/* Brake caliper */}
    <path
      fill="currentColor"
      d="M491.2,194c-1.5-1.5-2.9-3.1-4.3-4.6-3.4-3.5-7.9-7.7-11.5-10.8-1.9-1.6-3.3-2.5-6.6.9l-6.5,6.5c-10.6,10.6-17.5,17.6-22.2,22.5-3.1,3.1-6.2,6.2-9.8,9.8-8,8.2-9.5,13.9-10.1,18.6-1.2,8,3.9,15,9.3,19.9,21.2,19.2,27.9,42.5,28.9,59.6,1.6,26.5-7.8,54-23.1,70.9-21.4,23.6-10.7,41.4.4,52.9,3.7,4,6.9,7.2,10,10.5,4.3,4.7,10.2,10.6,17.9,18.8,4.9,5.2,6.1,3.7,9.3,1.9,4.6-2.6,10.1-8.8,13.1-12.1,71.9-79.4,74-193.3,5.1-265.1"
    />
  </svg>
);
